import React from "react";
import FileUploader  from "./FileUploader";
import ConfirmSkilagrein from '../confirm-skilagrein'
import { convertFileToPeriodData } from '../utils'


export default class UploadSkilagrein extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 0,
            processing: false,
            uploadedFiles: [],
            dots: ''
        }
        this.renderStep = this.renderStep.bind(this);
        this.onUploadConfirmed = this.onUploadConfirmed.bind(this);
        this.uploadedFiles = [];
        this.confirmBack = this.confirmBack.bind(this);
    }

    startDots() {
        if (this._dotsInterval) return;
        const frames = ['', '.', '..', '...'];
        let idx = 0;
        this._dotsInterval = setInterval(() => {
            this.setState({ dots: frames[idx % frames.length] });
            idx += 1;
        }, 400);
    }

    stopDots() {
        if (this._dotsInterval) {
            clearInterval(this._dotsInterval);
            this._dotsInterval = null;
        }
        this.setState({ dots: '' });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.processing && this.state.processing) {
            this.startDots();
        } else if (prevState.processing && !this.state.processing) {
            this.stopDots();
        }
    }

    componentWillUnmount() {
        this.stopDots();
    }


    async onUploadConfirmed(files) {
        this.uploadedFiles = files;
        this.setState({ step: 1, processing: true, processedFiles: [] });
        try {
            const results = await Promise.all(
                files.map(f => convertFileToPeriodData(f.file))
            );
            this.setState({ processedFiles: results, processing: false });            
        } catch (err) {
            alert('Ekki tókst að lesa inn skrá!\nHún er ekki skv. réttu sniði.\nLagaðu skrána og reyndu aftur.'+err);
            console.error('Ekki tókst að lesa inn skrá', err);
            this.setState({ processing: false });
        }
    }

    confirmBack(e) {
        this.setState({step: 0});
    }

    renderStep() {
        switch(this.state.step) {
            case 0:
                return <FileUploader uploadConfirmed={this.onUploadConfirmed}/>
            case 1:
                if (this.state.processing) {
                    return <div style={{margin:"10px 0 10px 0"}}>
                        <div className="msg warning-msg">Hleð skrám<span style={{marginLeft:8}}>{this.state.dots}</span></div>
                    </div>;
                }
                if (this.state.processedFiles && this.state.processedFiles.length > 0) {
                    return this.state.processedFiles.map((skilagrein, idx) =>
                        <ConfirmSkilagrein 
                            key={idx} 
                            skilagrein={skilagrein}
                            onBack={this.confirmBack}
                        />
                    );
                }
                return <div>Vantar skrár!</div>;
        }

    }


    render() {
        return (
            <div className={`step-${this.state.step} upload-skilagrein`}>
                <div className="register-skilagrein" >
                    {this.renderStep()}
                </div>
            </div>            
        )
    }

}